const Share = function () {

    const shareObject = (url) => {
        FB.ui({
            method: 'share',
            href: url
        }, (response) => { });
    }

    return {
        shareObject
    }
}

export default Share



// WEBPACK FOOTER //
// ./client/app/common/share/share.factory.js